// The grid kept over a map change (design/08 §3, issue 1329): the grid is not
// cleared when the DM changes the map, and the DM is told so and offered a
// one-click reset. Either way of changing the map (Properties' Change map…,
// the Library's Use as map) says so here; the shell shows the line.
import { defaultGrid, type Grid } from '@dragons-table/vtt-shared';

type Listener = (shown: boolean) => void;
let shown = false;
const listeners = new Set<Listener>();
const set = (next: boolean) => { if (next === shown) return; shown = next; for (const l of listeners) l(shown); };

/** Whether this grid is the one a table starts with, so a reset would change nothing. */
export const isDefaultGrid = (g: Grid): boolean => JSON.stringify(g) === JSON.stringify(defaultGrid());

export const gridKept = {
  get: () => shown,
  subscribe(l: Listener) { listeners.add(l); return () => { listeners.delete(l); }; },
  /** After a map change that went through: said only when there is a fitted grid to keep. */
  mapChanged(grid: Grid) { set(!isDefaultGrid(grid)); },
  dismiss() { set(false); },
};
